import { useAppSelector } from "../../store/hooks";
import drawerStyles from "../../styles/drawer.module.css";
import labels from "../../utils/labels";
import ColorChip from "../UI/chips/ColorChip";
import InfoBoxGreyBlackColumns from "./InfoBoxGreyBlackColumns";
import InfoBoxRow from "./InfoBoxRow";

const GeneralTaskInfoBox = () => {
  const selectedTask = useAppSelector(
    (state) => state.drawerSlice.selectedTask,
  );

  const priorityConfig: Record<string, { label:
  string; color: string }> = {
    HIGH: { label: labels.high, color:
  "var(--col-error-3)" },
    LOW: { label: labels.low, color:
  "var(--col-graph-first-2)" },
  };
  const defaultPriority = { label: labels.normal,
  color: "var(--col-interaction-tertiary)" };

  const { label: priorityLabel, color:
  priorityColor } =
    priorityConfig[selectedTask?.task.priority ??
  ""] ?? defaultPriority;

  const task = selectedTask?.task;
  // Operational tasks (lunch, planning, ...) have no citizen and may have no address.
  const postalAndDistrict = [task?.postalCode, task?.district]
    .filter(Boolean)
    .join(" ");
  const address = [task?.address, postalAndDistrict].filter(Boolean).join(", ");
  const citizen = task?.client.description;

  return (
    <div className={drawerStyles.generalTaskInfoBox}>
      {selectedTask && (
        <>
          <InfoBoxRow title={labels.priority}>
            <ColorChip text={priorityLabel} color={priorityColor} />
          </InfoBoxRow>
          {selectedTask.employeeName && (
            <InfoBoxRow title={labels.hoverEmployee}>
              <InfoBoxGreyBlackColumns
                key={labels.hoverEmployee}
                firstColumn={labels.hoverEmployee}
                secondColumn={selectedTask.employeeName}
              />
            </InfoBoxRow>
          )}
          {(citizen || address) && (
            <InfoBoxRow title={labels.citizenDetails}>
              {citizen && (
                <InfoBoxGreyBlackColumns
                  key={labels.citizen}
                  firstColumn={labels.citizen}
                  secondColumn={citizen}
                />
              )}
              {address && (
                <InfoBoxGreyBlackColumns
                  key={labels.address}
                  firstColumn={labels.address}
                  secondColumn={<span>{address}</span>}
                />
              )}
            </InfoBoxRow>
          )}
          {selectedTask.task.requiredSkills?.length > 0 && (
            <InfoBoxRow title={labels.skillRequirement}>
              <InfoBoxGreyBlackColumns
                key={labels.skills}
                firstColumn={labels.skills}
                secondColumn={selectedTask.task.requiredSkills}
              />
            </InfoBoxRow>
          )}
        </>
      )}
    </div>
  );
};

export default GeneralTaskInfoBox;
